'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { DateRangeFilter, LabelDefault } from '@terra/ui-design-system';
import { Box, HStack, VStack } from '@terra/ui-styled-system';

export function ListPageAdvancedFilters({ children }: { children: ReactNode }) {
  return (
    <Box pt="3" borderTopWidth="1px" borderColor="border.neutral.subtle">
      <HStack gap="4" alignItems="stretch" flexWrap="wrap">
        {children}
      </HStack>
    </Box>
  );
}

const COMPACT_FILTER_ROW_HEIGHT = '30px';

export function ListPageAdvancedFilterField({
  label,
  children,
}: {
  label?: string;
  children: ReactNode;
}) {
  if (!label) {
    return (
      <Box
        alignSelf="flex-end"
        display="flex"
        alignItems="center"
        h={COMPACT_FILTER_ROW_HEIGHT}
      >
        {children}
      </Box>
    );
  }

  return (
    <VStack gap="1" alignItems="flex-start" justifyContent="flex-end">
      <LabelDefault color="fg.muted">{label}</LabelDefault>
      {children}
    </VStack>
  );
}

export function ListPageDateRangeField({
  label,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: {
  label: string;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}) {
  const t = useTranslations('proxy.filters');

  return (
    <ListPageAdvancedFilterField label={label}>
      <DateRangeFilter
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        size="sm"
        startPlaceholder={t('startDate')}
        endPlaceholder={t('endDate')}
      />
    </ListPageAdvancedFilterField>
  );
}
